import {
    ADD_TIRE,
    ADD_TIRE_QUANTITY,
    CLEAR_CART,
    DECREMENT_CART_QUANTITY,
    INCREMENT_CART_QUANTITY,
    RECALCULATE,
    REMOVE_TIRE,
    SET_BLOB,
    SET_INSTALLATION
} from "./ActionTypes";
import {QUANTITY_MAX} from "../../shared/constants";

const initialState = {
    cart: [],
    updateQuantity: false,
    blobOfCart: null
};

const cartReducer = (state = initialState, action) => {
    if (action.payload) {
        switch (action.type) {
            case ADD_TIRE:
                return {
                    ...state,
                    cart: [...state.cart, action.payload]
                };
            case CLEAR_CART:
                return {
                    ...state,
                    cart: []
                };
            case ADD_TIRE_QUANTITY: {
                const index = state.cart.findIndex(tire => tire.gmPartNum === action.payload.gmPartNum);
                const newSelectedTires = [...state.cart];
                if(newSelectedTires[index].quantity + 1 <= QUANTITY_MAX){
                    newSelectedTires[index].quantity = newSelectedTires[index].quantity + 1;
                }
                return {
                    ...state,
                    cart: newSelectedTires
                };
            }
            case RECALCULATE: {
                return Object.assign({}, state, {
                    updateQuantity: (state.updateQuantity = action.payload.updateQuantity),
                });
            }
            case INCREMENT_CART_QUANTITY: {
                const index = state.cart.findIndex(tire => tire.gmPartNum === action.payload.gmPartNum);
                const newCart = [...state.cart];
                newCart[index].quantity = newCart[index].quantity + 1;
                return {
                    ...state,
                    cart: newCart
                }
            }
            case DECREMENT_CART_QUANTITY: {
                const index = state.cart.findIndex(tire => tire.gmPartNum === action.payload.gmPartNum);
                const newCart = [...state.cart];
                newCart[index].quantity = newCart[index].quantity - 1;
                return {
                    ...state,
                    cart: newCart
                }
            }
            case REMOVE_TIRE:
                const index = state.cart.findIndex(tire => tire.gmPartNum === action.payload.gmPartNum);
                const newCart = [...state.cart];
                      newCart.splice(index,1);
                return {
                    ...state,
                    cart: newCart
                };
            case SET_INSTALLATION: {
                const newCart = [...state.cart];
                newCart[action.payload.tireIndex].installation = !newCart[action.payload.tireIndex].installation;
                return {
                    ...state,
                    cart: newCart
                };
            }
            case SET_BLOB:
                return {
                    ...state,
                    blobOfCart: action.payload.blobOfCart
                };
            default:
                return state;
        }
    } else {
        return state;
    }
};

export default cartReducer;
